import { useState, useRef } from 'react';
import { useEspecificacao } from '../../contexts/EspecificacaoContext';
import Folha from './Folha';
import Quantidade from './Quantidade';
import SeletorAmbientes from './SeletorAmbientes';
import { UNIDADES_LIVRE, reduzirImagem } from '../../utils/especificacao';

/**
 * "Não achei no catálogo": o arquiteto descreve o item (nome, marca, medida, foto).
 * Ele entra na especificação e no PDF como qualquer outro, e vira demanda pro time
 * de compras avaliar se a Centrão consegue trazer.
 */
export default function ItemLivreModal() {
  const { livre, fecharLivre, ativa, salvarLivre, avisar } = useEspecificacao();
  const item = livre?.item;
  const [f, setF] = useState(() => ({
    nome: item?.nome || '', marca: item?.marca || '', medida: item?.medida || '',
    categoria: item?.departamento && item.departamento !== 'Outros' ? item.departamento : '',
    unidade: item?.unidade || 'UN', quantidade: item?.quantidade || 1,
    ambientes: item?.ambientes || [], observacao: item?.observacao || '',
  }));
  const [foto, setFoto] = useState(item?.foto || null);
  const [fotoMudou, setFotoMudou] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const arquivo = useRef(null);
  const set = (k) => (v) => setF(s => ({ ...s, [k]: v?.target ? v.target.value : v }));

  const escolherFoto = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    try { setFoto(await reduzirImagem(file, { max: 1000 })); setFotoMudou(true); setErro(''); }
    catch (err) { setErro(err.message); }
  };

  const salvar = async () => {
    setSalvando(true); setErro('');
    try {
      const dados = { ...f, ...(fotoMudou ? { foto: foto || null } : {}) };
      await salvarLivre(dados, item?.id);
      avisar(item ? 'Item atualizado' : 'Item adicionado — o time de compras vai avaliar');
      fecharLivre();
    } catch (e2) { setErro(e2.response?.data?.error || 'Não foi possível salvar'); }
    finally { setSalvando(false); }
  };

  return (
    <Folha
      titulo={item ? 'Editar item fora do catálogo' : 'Item fora do catálogo'}
      subtitulo={item ? null : 'Não achou o produto? Descreva aqui — ele vai na sua especificação e a Centrão avalia se consegue trazer.'}
      onFechar={fecharLivre}
      largura={560}
      rodape={(
        <>
          <button type="button" className="esp-btn-sec" onClick={fecharLivre} disabled={salvando}>Cancelar</button>
          <button type="button" className="esp-btn" onClick={salvar} disabled={salvando || f.nome.trim().length < 2 || !ativa}>
            {salvando ? 'Salvando…' : item ? 'Salvar' : <><i className="bi bi-plus-lg" />Adicionar</>}
          </button>
        </>
      )}
    >
      {erro && <div className="esp-erro"><i className="bi bi-exclamation-circle" />{erro}</div>}

      <div className="esp-livre-topo">
        <button type="button" className={`esp-livre-foto ${foto ? 'tem' : ''}`} onClick={() => arquivo.current?.click()}>
          {foto ? <img src={foto} alt="" /> : <><i className="bi bi-camera" /><span>Foto</span></>}
        </button>
        <input ref={arquivo} type="file" accept="image/*" hidden onChange={escolherFoto} />
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <label className="esp-rotulo mt-0">O que é o item?</label>
          <input className="esp-campo" value={f.nome} onChange={set('nome')} maxLength={200} autoFocus
            placeholder="Ex.: Pendente Beat Fat — preto" />
          {foto && <button type="button" className="esp-link mt-1" onClick={() => { setFoto(null); setFotoMudou(true); }}><i className="bi bi-x" />Tirar foto</button>}
        </div>
      </div>

      <div className="esp-grade2">
        <div>
          <label className="esp-rotulo">Marca / fabricante <span className="opc">opcional</span></label>
          <input className="esp-campo" value={f.marca} onChange={set('marca')} maxLength={100} placeholder="Ex.: Tom Dixon" />
        </div>
        <div>
          <label className="esp-rotulo">Medida / modelo <span className="opc">opcional</span></label>
          <input className="esp-campo" value={f.medida} onChange={set('medida')} maxLength={60} placeholder="Ex.: Ø 47 cm" />
        </div>
      </div>

      <label className="esp-rotulo">Categoria <span className="opc">agrupa no PDF</span></label>
      <select className="esp-campo" value={f.categoria} onChange={set('categoria')}>
        <option value="">Outros</option>
        {(ativa?.departamentos || []).map(d => <option key={d} value={d}>{d}</option>)}
      </select>

      <label className="esp-rotulo">Quantidade</label>
      <div className="esp-qtd-linha">
        <Quantidade valor={Number(f.quantidade)} unidade={f.unidade} onChange={set('quantidade')} />
        <select className="esp-campo esp-unid" value={f.unidade} onChange={set('unidade')} aria-label="Unidade">
          {UNIDADES_LIVRE.map(([v, t]) => <option key={v} value={v}>{t}</option>)}
        </select>
      </div>

      <label className="esp-rotulo">Para quais ambientes? <span className="opc">opcional</span></label>
      <SeletorAmbientes valor={f.ambientes} onChange={set('ambientes')} sugestoes={ativa?.sugestoesAmbiente || []} />

      <label className="esp-rotulo">Observação <span className="opc">opcional</span></label>
      <textarea className="esp-campo" rows={2} maxLength={500} value={f.observacao} onChange={set('observacao')}
        placeholder="Link do fabricante, acabamento, referência..." />
    </Folha>
  );
}
